import iconNames from '@kkday/style-dictionary/build/web/sprite/iconNames.json';

/**
 * 檢查 KkIcon 的 name 是否正確
 *
 * @param {String} iconName - KkIcon 的使用名稱
 * @returns {Boolean} has icon or not
 *
 * @example
 * kkCheckIcon('ic_airplane_fill'); // true
 * kkCheckIcon('airplane_fill'); // false
 */
export function kkCheckIcon(iconName) {
	return iconNames.includes(iconName);
}

/**
 * 提供 KkIcon 的名稱列表
 *
 * @type {Array<String>}
 *
 * @example
 * console.log(kkIconNameList); // ['ic_airplane_fill', ...]
 */
export const kkIconNameList = iconNames;
